import React from 'react'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import Layout from '../../components/Layout'
import Survey from './Survey'

// @ts-ignore @todo add apprioprate declaration file
import editIconWhite from '../../images/editIconWhite.svg'

function SurveyPreview() {
  const surveyId = location.pathname.substring(
    location.pathname.lastIndexOf('/') + 1
  )
  return (
    <Layout>
      <Heading title="Ankiety">
        <Button
          link={`/app/surveys/${surveyId}`}
          label="Edycja"
          icon={editIconWhite}
          width="auto"
          altTag=""
          srText=""
          imgAriaHidden={true}
        />
      </Heading>
      <Survey preview={true} />
    </Layout>
  )
}

export default SurveyPreview
